import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentcolor",
      d: "M2.854 11.467c-.517.17-1.01.34-1.386.509C-.224 12.824.01 15.442.01 15.564a.49.49 0 0 0 .47.436h15.035a.49.49 0 0 0 .47-.436c0-.122.258-2.74-1.433-3.588-.376-.194-.87-.34-1.386-.51-1.175-.387-2.631-.848-2.89-1.745.024-.145.07-.582.4-.897.634-.654 1.315-2.472 1.315-4.266v-.025c0-.097-.188-2.618-1.574-3.685C10.23.655 9.455 0 7.998 0h-.023C6.542 0 5.767.655 5.579.824 4.169 1.891 4.005 4.412 4.005 4.51v.024c0 1.794.681 3.612 1.315 4.267.33.34.376.776.4.897-.235.921-1.692 1.382-2.866 1.77"
    }, null, -1)
  ]))]))
}
export default { render: render }